<template>
  <v-toolbar class="offset-sm1" color="transparent"  dark fixed flat >
    <v-layout wrap>
      <v-flex xs6 md5 offset-md1 class="text-xs-left" >
        <v-img @click.stop="$store.commit('toggleLeftDrawer', true)"
             src="static/images/sfh_icon_with_expansion_indicators.png" style="cursor:pointer;"
             alt="sfh" width="50">
        </v-img>
      </v-flex>
      <v-flex xs6 md5 class="text-xs-right" >
        <v-btn fab color="transparent" @click.stop="$store.commit('toggleRightDrawer', true)"
               class="elevation-2" style="width:42px;height:42px;z-index:1;">

          <div class="user-avatar elevation-10"
               :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'40px',width:'40px' }"></div>

<!--          <v-avatar size="40px"-->
<!--                    color="grey lighten-4">-->
<!--            <v-img lazy-src="static/images/avatar180x.jpg" :src="$store.getters['user/avatar']" ></v-img>-->
<!--          </v-avatar>-->
<!--          -->
        </v-btn>
        <span class="notranslate"><v-icon  id="cogenti-sfh-logo" @click.stop="$store.commit('toggleRightDrawer', true)" color="black">menu</v-icon></span>
      </v-flex>
    </v-layout>
  </v-toolbar>
</template>

<script>
export default {
  name: 'PlainToolbar',
  data () {
    return {
    }
  },
  methods: {
    // sfhImage () {
    //   return require('@/assets/images/sfh_icon_with_expansion_indicators.png')
    // },
    // userImage () {
    //   return require('@/assets/images/avatar180x.jpg')
    // }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layouts/PlainToolbar.vue